export const INVITE_LINKS = {
  registrationLink: "https://atila.in/mr-self-registration", // Add more invite links here if needed
};

export const dropdownOption = [
  {
    id: "1",
    name: "Yes",
  },
  {
    id: "2",
    name: "No",
  },
];

export const employeeGender = [
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
];

/* pop failure modal */
export const failureModalData = {
  title: "Warning",
  ErrorMsg: "",
};

export const companyCodeDropDownOptions = [
  { id: 1, code: "NR", name: "NR - Norma", description: "Norma" },
  { id: 2, code: "MR", name: "MR - Medirent", description: "Medirent" },
  { id: 3, code: "XA", name: "XA - Xamax", description: "Xamax" },
];

export const vendorCategoryData = [
  // { id: 1, code: "V01", name: "Vendor", description: "Vendor" },
  // { id: 2, code: "V02", name: "New Patient", description: "NewPatient" },
  // { id: 3, code: "V03", name: "Old Patient", description: "OldPatient" },
  { id: 4, code: "V04", name: "Hospital", description: "Hospital" },
  // { id: 5, code: "V05", name: "Consultant", description: "Consultant" },
  // {
  //   id: 6,
  //   code: "V06",
  //   name: "Service Provider",
  //   description: "ServiceProvider",
  // },
  // { id: 7, code: "V07", name: "Other", description: "Other" },
  // {
  //   id: 8,
  //   code: "V08",
  //   name: "Distributor",
  //   description: "Distributor",
  // },
  // {
  //   id: 9,
  //   code: "V09",
  //   name: "Manufacturer",
  //   description: "Manufacturer",
  // },
  // {
  //   id: 10,
  //   code: "V10",
  //   name: "Business Logistics",
  //   description: "BusinessLogistics",
  // },
  {
    id: 11,
    code: "V11",
    name: "Doctor",
    description: "Doctor",
  },
  {
    id: 12,
    code: "V12",
    name: "Patient",
    description: "Patient",
  },
   {
    id: 13,
    code: "V13",
    name: "Nursing",
    description: "Nursing",
  },
  {
    id: 14,
    code: "V14",
    name: "Service Person",
    description: "ServicePerson",
  },
];

export const ID_PROOF_OPTIONS = [  
  { id: 1, name: "Adhar Card" },  
  { id: 2, name: "Driving License" },  
  { id: 3, name: "Voter ID" },  
  { id: 4, name: "PAN Card" },  
  { id: 5, name: "Passport" },  
];  


export const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_AADHAAR_NUMBER: "Please enter a valid 12 digit Aadhaar number.",
  VALID_PAN_NUMBER: "Please enter a valid Pan number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  VALID_BANK_ACC: "validate bank account number",
  EXISTS_MAIL_ID: "Email already exists",
  EXISTS_CONTACT_NUMBER: "Contact Number already exists",
  EXISTS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXISTS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  DOC_NUMBER: "Invalid Document Number",
  MOBILE_NUMBER: "Mobile number should contain 10 digits.",
};


export const doctorManagerDropDownOption = [
  { id: 1, code: "Gagandeep", name: "Gagandeep", description: "Gagandeep" },
  { id: 2, code: "Kishore", name: "Kishore Sharma", description: "Kishore Sharma" },
  { id: 3, code: "Nithin", name: "Nithin Sharma", description: "Nithin Sharma" },
  { id: 4, code: "Sanjay", name: "Sanjay Srivastava", description: "Sanjay Srivastava" },
];


// Add these constants
export const NURSE_CATEGORY_OPTIONS = [
  { id: 1, name: "ANM (Auxiliary Nurse Midwife)", code: "ANM" },
  { id: 2, name: "GNM (General Nursing Midwifery)", code: "GNM" },
  { id: 3, name: "B.Sc Nursing", code: "BSC" },
  { id: 4, name: "M.Sc Nursing", code: "MSC" },
  { id: 5, name: "Patient Care Attendant (GD)", code: "PCA" },
];

export const NURSE_SPECIALIZATION_OPTIONS = [
  { id: 1, name: "General Care", code: "GEN" },
  { id: 2, name: "ICU / Critical Care", code: "ICU" },
  { id: 3, name: "Pediatric / Baby Care", code: "PED" },
  { id: 4, name: "Geriatric / Elderly Care", code: "GER" },
  { id: 5, name: "Post-Operative Care", code: "POC" },
  { id: 6, name: "Palliative / Hospice", code: "PAL" },
];